export const initDynamicButtons = () => {
  const dynamicButtons = document.querySelectorAll('.dynamic');
  const inPageNav = document.getElementById('inPageNav');
  let btnArray = [];

  const observerOptions = {
    root: null,
    rootmargin: '0px',
    threshold: 1.0
  }

  const dynamicWatch = (entries) => {
    entries.forEach((entry) => {
      let itemClone;
      let item = entry.target;
      if(!entry.isIntersecting){
        // itemClone = $(item).clone(true);
        itemClone = item.cloneNode(true);
        btnArray.push([item, itemClone]);
        itemClone.addEventListener('click', (e) => {
          e.preventDefault();
          item.click();
        });
        const inPageButtons = document.querySelector('.in-page-button');
        if (inPageButtons) {
          inPageButtons.appendChild(itemClone);
        }
        // $('.in-page-button').append(itemClone);
        item.classList.add('cloned');
      } else {
        itemClone = btnArray.map((btn, index) => {
          if(btn[0] == item) {
            let target = btn[1];
            btnArray.splice(index,1);
            return target;
          }
        })
        // $(itemClone[0]).remove();
        if (itemClone[0]) {
          itemClone[0].remove();
        }
        item.classList.remove('cloned');
      }
    })
  }

  const observer = new IntersectionObserver(dynamicWatch, observerOptions);

  dynamicButtons.forEach((btn) => {
    observer.observe(btn);
  })

};



// WEBPACK FOOTER //
// ./src/js/components/dynamic-buttons.js